var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        title: "Atualizar descrição",
        subtitle: "Insira a nova descrição para o pedido"
      },
      on: {
        close: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c("v-textarea", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|max:1024",
                expression: "'required|max:1024'"
              }
            ],
            attrs: {
              name: "description",
              label: "descrição",
              required: "",
              "error-messages": _vm.errors.first("description"),
              error: _vm.errors.has("description"),
              rows: "5"
            },
            model: {
              value: _vm.description,
              callback: function($$v) {
                _vm.description = $$v
              },
              expression: "description"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "button",
          {
            staticClass: "btn bg-purple-outline",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_vm._v("\n      cancelar\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "btn bg-purple", on: { click: _vm.submit } },
          [_vm._v("\n      Atualizar descrição\n    ")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77208f7b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77208f7b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Orders/ShowOrder/UpdateDescription.vue
// module id = null
// module chunks = 